import React from 'react';
import { PEILink } from '@/common';
import styles from '@/styles/HeaderCta.module.scss';

export const HeaderCta = ({ placeHolder, href = '#/' }: { placeHolder: string; href?: string }) => {
  return (
    <PEILink href={href} className={styles['cta-link']}>
      {placeHolder}
    </PEILink>
  );
};
